/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ProjectMenuInfo = {
    ID: string;
    PMID: string;
    IDX: number;
    LBL: string;
    ICON?: string;
    PATH?: string;
    HICON?: ProjectMenuInfo.HICON;
    CHILD?: Array<ProjectMenuInfo>;
};

export namespace ProjectMenuInfo {

    export enum HICON {
        NEW = 'NEW',
        HOT = 'HOT',
        UPDATE = 'UPDATE',
        NONE = 'NONE',
    }


}

